import React, { useEffect, useState } from 'react';
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/react';
import clsx from 'clsx';

import { Container } from './Container';

const features = [
  {
    title: 'Map',
    description: 'Find services available across the UK that are SEND accessible',
    image: '/assets/1.jpg',
  },
  {
    title: 'Bookings',
    description: 'A platform to check availability and\nbook any service directly. Allows\neasy communication between\nfamilies, providers, and local\nauthorities.',
    image: '/assets/2.jpg',
  },
  {
    title: 'Message',
    description: 'Messaging system for easy\ncommunication between families,\nproviders, and local authorities.\nAsk questions – get answers!',
    image: '/assets/3.jpg',
  },
  {
    title: 'Blog',
    description: 'Keep up to date with everything SEND through our regular blogs.',
    image: '/assets/4.jpeg',
  },
  {
    title: 'Resources',
    description: 'A library of downloadable SEND information, tools, advice, and guidance.',
    image: '/assets/5.jpg',
  },
  {
    title: 'Products',
    description: 'SEND products recommended, reviewed and categorised into areas of need.',
    image: '/assets/6.jpg',
  },
  
];

export default function PrimaryFeatures() {
  const [tabOrientation, setTabOrientation] = useState('horizontal');

  useEffect(() => {
    const lgMediaQuery = window.matchMedia('(min-width: 1024px)');

    function onMediaQueryChange({ matches }) {
      setTabOrientation(matches ? 'vertical' : 'horizontal');
    }

    onMediaQueryChange(lgMediaQuery);
    lgMediaQuery.addEventListener('change', onMediaQueryChange);

    return () => {
      lgMediaQuery.removeEventListener('change', onMediaQueryChange);
    };
  }, []);

  return (
    <section id="features" aria-label="Features for running your books" className="relative overflow-hidden bg-blue-600 pb-28 pt-20 sm:py-32">
      <Container className="relative">
        <div className="max-w-2xl md:mx-auto md:text-center xl:max-w-none">
        <h2 className="font-display text-3xl tracking-tight text-white sm:text-4xl md:text-5xl font-semibold">
  More than just a website
</h2>

          <p className="mt-6 text-lg tracking-tight text-blue-100">
          enableSEND has built a community that brings together tools, resources, and help all in one place, improving support for children and young adults with SEND.
          </p>
        </div>
        <TabGroup
          className="mt-16 grid grid-cols-1 items-center gap-y-10 pt-10 sm:gap-y-10 md:mt-20 lg:grid-cols-12 lg:pt-0"
          vertical={tabOrientation === 'vertical'}
        >
          {({ selectedIndex }) => (
            <>
              <div className="-mx-4 flex overflow-x-auto pb-4 sm:mx-0 sm:overflow-visible sm:pb-0 lg:col-span-5" style={{ touchAction: 'pan-x' }}>
                <TabList className="relative z-10 flex gap-x-10 whitespace-nowrap px-4 sm:mx-auto sm:px-0 lg:mx-0 lg:block lg:gap-y-8 lg:whitespace-normal">
                  {features.map((feature, featureIndex) => (
                    <div
                      key={feature.title}
                      className={clsx(
                        'group relative rounded-full px-4 py-2 lg:rounded-l-xl lg:rounded-r-none lg:px-6 lg:py-4',
                        selectedIndex === featureIndex
                          ? 'bg-white/5 lg:bg-white/5 lg:ring-1 lg:ring-inset lg:ring-white/10'
                          : 'hover:bg-white/10 lg:hover:bg-white/5',
                      )}
                    >
                      <h3>
                        <Tab
                          className={clsx(
                            'font-display text-lg ui-not-focus-visible:outline-none',
                            selectedIndex === featureIndex
                              ? 'text-white'
                              : 'text-blue-100 hover:text-white lg:text-white',
                          )}
                        >
                          <span className="absolute inset-0 rounded-full lg:rounded-l-xl lg:rounded-r-none" />
                          {feature.title}
                        </Tab>
                      </h3>
                      <p
                        className={clsx(
                          'mt-2 hidden text-sm lg:block',
                          selectedIndex === featureIndex
                            ? 'text-white'
                            : 'text-blue-100 group-hover:text-white',
                        )}
                      >
                        {feature.description}
                      </p>
                    </div>
                  ))}
                </TabList>
              </div>
              <TabPanels className="lg:col-span-7">
                {features.map((feature) => (
                  <TabPanel key={feature.title} unmount={false}>
                    <div className="relative sm:px-6 lg:hidden">
                      <p className="relative mx-auto max-w-2xl text-base text-white sm:text-center">
                        {feature.description}
                      </p>
                    </div>
                    <div className="mt-10 w-full overflow-hidden rounded-xl bg-slate-50 shadow-xl shadow-blue-900/20 sm:w-auto lg:mt-0 lg:w-[55rem]">
                      <img
                        className="w-full h-auto object-contain object-center"
                        src={feature.image}
                        alt={feature.title}
                      />
                    </div>
                  </TabPanel>
                ))}
              </TabPanels>
            </>
          )}
        </TabGroup>
      </Container>
    </section>
  );
}
